/* DeSiM 公式店 — カートページの数量ステッパー ＋ 受け取り日セレクト。
   AJAX 不使用（brief 指示）: ±ボタンで number input の値を書き換え、フォームごと
   通常の POST で /cart へ送信する（japan-esim 参考実装と同じ方式）。
   本物の Shopify では /cart への POST が `updates[<line key>]` を読んで数量を
   更新する（main-cart.liquid の input name 参照）。 */
(function () {
  'use strict';
  var form = document.querySelector('[data-ds-cart]');
  if (!form) return;

  form.querySelectorAll('[data-ds-qty]').forEach(function (qty) {
    var input = qty.querySelector('.ds-qty__input');
    if (!input) return;
    qty.querySelectorAll('[data-ds-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-ds-qty-step'), 10) || 0;
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
        input.value = next;
        form.submit();
      });
    });
    input.addEventListener('change', function () {
      form.submit();
    });
  });

  /* fix round 1: 「QRコード受け取り日」セレクトに「今すぐ！」＋今日から14日分の
     予約日を追加する。

     日本時間（JST/Asia-Tokyo）の算出方法について: Intl.DateTimeFormat +
     timeZone: 'Asia/Tokyo' も使えるが、JST は夏時間を持たない**恒久的に
     UTC+9 固定**のタイムゾーンなので、UTC エポックに 9 時間を足してから
     UTC ゲッター（getUTCFullYear 等）で読む方が ICU データの有無やロケール
     サポートに依存せず、どの JS 実行環境（本地描画ハーネス含む）でも同じ結果に
     なる。この等価性は Asia/Tokyo に限って常に成立する（他のタイムゾーンでは
     夏時間があるので固定オフセット計算は使えない）。 */
  function jstPartsForOffsetDays(offsetDays) {
    var JST_OFFSET_MS = 9 * 60 * 60 * 1000;
    var DAY_MS = 24 * 60 * 60 * 1000;
    var d = new Date(Date.now() + JST_OFFSET_MS + offsetDays * DAY_MS);
    return {
      year: d.getUTCFullYear(),
      month: d.getUTCMonth() + 1,
      day: d.getUTCDate(),
      weekday: d.getUTCDay(), // 0=日 … 6=土
    };
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* JST の今日（yyyy-mm-dd）。日付の大小は文字列比較で足りる形にそろえる。 */
  function todayYmd() {
    var t = jstPartsForOffsetDays(0);
    return t.year + '-' + pad2(t.month) + '-' + pad2(t.day);
  }

  /* 画面で直した値をカート属性にも反映する（そのまま別の経路で結算されても古い値が載らない）。
     🔴 1 回の POST にまとめる。受け取り日と渡航日を別々に同時送信すると、後から
     着いた方がカート属性を丸ごと上書きし、先の修正が消えた（2026-09-26 実測）。 */
  var pendingAttrs = null;
  function syncCartAttributes(attrs) {
    if (pendingAttrs) {
      for (var k in attrs) pendingAttrs[k] = attrs[k];
      return;
    }
    pendingAttrs = {};
    for (var k2 in attrs) pendingAttrs[k2] = attrs[k2];
    setTimeout(function () {
      var body = pendingAttrs;
      pendingAttrs = null;
      try {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: body })
        }).catch(function () {});
      } catch (e) {}
    }, 0);
  }

  /* 画面文言は main-cart.liquid が出す <script type="application/json" data-ds-i18n="shop">
     から読む（locale の shop.cart.weekdays / shop.cart.pickup_date）。JS に日本語を持たない。
     読めなければ曜日無しの「M/D」だけにする。 */
  var i18n = {};
  try {
    var i18nEl = document.querySelector('script[data-ds-i18n="shop"]');
    if (i18nEl) i18n = JSON.parse(i18nEl.textContent) || {};
  } catch (e) {
    i18n = {};
  }
  var WEEKDAYS = String(i18n.weekdays || '').split(',');
  var PICKUP_DATE = i18n.pickup_date || '';

  function pickupLabel(parts) {
    var wd = WEEKDAYS.length === 7 ? WEEKDAYS[parts.weekday] : '';
    if (!PICKUP_DATE || !wd) return parts.month + '/' + parts.day;
    return PICKUP_DATE.replace('%M', String(parts.month))
      .replace('%D', String(parts.day))
      .replace('%W', wd);
  }

  var pickupSelect = document.querySelector('[data-ds-pickup-select]');
  if (pickupSelect) {
    /* 最終全分岐レビュー Important 1（再水和欠落）の修正: main-cart.liquid が
       cart.attributes['QRコード受け取り日'] を data-ds-persisted-pickup に
       焼き込んでいる。ここでいったん読んでおいてから14日分の option を
       追加する — SSR は「今すぐ！」の1件しか option を持たないので、
       予約日が永続化されていても再レンダー直後は選択肢自体が存在せず、
       select は黙って "now" にフォールバックしてしまう（数量変更のたびに
       画面が実データを裏切って「今すぐ！」に巻き戻る）。 */
    var persisted = pickupSelect.getAttribute('data-ds-persisted-pickup') || '';
    /* 🔴 過去の受け取り日はカートに残っていても使わない（「今すぐ！」へ戻す）。
       以前は 14 日窓の外の値をそのまま選択肢に足していたので、何日も前に選んだ
       日付が過去日のまま画面に出て、そのまま注文に載った（2026-09-26 報告）。 */
    if (/^\d{4}-\d{2}-\d{2}$/.test(persisted) && persisted < todayYmd()) {
      persisted = 'now';
      syncCartAttributes({ 'QRコード受け取り日': 'now' });
    }
    var matchedPersisted = persisted === '' || persisted === 'now';

    for (var i = 1; i <= 14; i += 1) {
      var parts = jstPartsForOffsetDays(i);
      var option = document.createElement('option');
      /* CONTRACT（後続の発卡フルフィルメントタスクが依拠）:
         value="now" は今すぐ！、それ以外は "yyyy-mm-dd"（機械可読）。
         表示文字列（画面に見せる用）は locale の書式（ja は「9/12（土）」）。 */
      var value = parts.year + '-' + pad2(parts.month) + '-' + pad2(parts.day);
      option.value = value;
      option.textContent = pickupLabel(parts);
      if (persisted === value) {
        option.selected = true;
        matchedPersisted = true;
      }
      pickupSelect.appendChild(option);
    }

    /* 永続化された予約日が14日窓の外（例: 15日目以降を選んだ後に別セッションから
       戻ってきた等）だった場合、黙って "now" に落とすのではなく、その値専用の
       <option> を追加して選択する（実データを画面から消さない）。 */
    if (!matchedPersisted) {
      var extra = document.createElement('option');
      extra.value = persisted;
      extra.textContent = persisted;
      extra.selected = true;
      pickupSelect.appendChild(extra);
    }
  }

  /* 利用開始日（渡航日）の date input は今日より前を選べないようにする。
     🔴 min だけでは足りない: カート属性に**以前選んだ日付**が残っていると、それが
     過去日になっていても value としてそのまま表示・送信される（2026-09-26 に
     9/8 のまま出ていた実機報告）。過去日なら消して、選び直しを促す。 */
  var startDateInput = document.querySelector('[data-ds-start-date]');
  if (startDateInput) {
    var today = todayYmd();
    startDateInput.min = today;
    if (startDateInput.value && startDateInput.value < today) {
      startDateInput.value = '';
      syncCartAttributes({ '利用開始日（渡航日）': '' });
      var hint = document.createElement('p');
      hint.setAttribute('role', 'status');
      hint.style.cssText = 'margin:6px 0 0;font-size:12px;line-height:1.5;color:#d9480f;';
      hint.textContent = /^en/i.test(document.documentElement.lang || '')
        ? 'The date you chose earlier has passed, so we cleared it. Please select your travel date again.'
        : '以前選んだ日付が過ぎていたため、クリアしました。渡航日を選び直してください。';
      startDateInput.insertAdjacentElement('afterend', hint);
      startDateInput.addEventListener('change', function () {
        if (hint.parentNode) hint.parentNode.removeChild(hint);
      });
    }
  }
})();
